import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-fade';

register('announcement', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';
    this.userSettings = JSON.parse(this.settings);

    const initAnnouncementSlider = (slider) => {
      if (!slider) {
        return;
      }
      // eslint-disable-next-line no-unused-vars
      const flickity = new Flickity(slider, {
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        cellAlign: 'left',
        fade: true,
        watchCSS: true,
        contain: true,
        autoPlay: this.userSettings.slide_speed ? Number(this.userSettings.slide_speed) : true,
        on: {
          ready() {
            slider.classList.add('is-visible');
          },
        },
      });
    };

    const announcementSlider = document.querySelector('.announcement-slider');
    if (announcementSlider) initAnnouncementSlider(announcementSlider);
  },
});
